<div class="layoutBlock">
	<div class="columnHalf">
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>

		<res-publication-edit-main-data
            [hisDynamicContent]="'I18nValue.basicData'" [dynamicComponent]="publication._dynamicComponent"
            [publication]="publication"
            [childPublication]="childPublication"
            [publicationTypeChildParentMap]="publicationTypeChildParentMap"
            [changeRequestValueGroup]="changeRequestValueGroup"
			(publicationTypeChange)="onPublicationTypeChange($event)"
            (navigationLastUrlChange)="onNavigationLastUrlChange($event)"
            (duplicatesByTitleChange)="onDuplicatesByTitleChange($event)">
		</res-publication-edit-main-data>
		
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
		
		<res-publication-creator-panel 
            [hisDynamicContent]="'fs.res.publication.Publication.creators'" [dynamicComponent]="publication._dynamicComponent"
			[(creatorType)]="publication.publicationCreatorType" 
			[(creators)]="publication.creators">
		</res-publication-creator-panel>
		
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
	</div>
	
	<div class="columnHalf">		
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>	
		
		<res-publication-edit-additional-data
            [hisDynamicContent]="'I18nValue.additionalData'"
            [dynamicComponent]="publication._dynamicComponent"
			[publication]="publication"
            [publicationTypeChildParentMap]="publicationTypeChildParentMap"
            [childPublication]="childPublication"
            [changeRequestValueGroup]="changeRequestValueGroup"
            (navigationLastUrlChange)="onNavigationLastUrlChange($event)"
            (navigateToCreateParentOnNextSave)="navigateToCreateParentOnNextSave.emit($event)"
            (navigateToEditParentOnNextSave)="navigateToEditParentOnNextSave.emit($event)">
		</res-publication-edit-additional-data>
		
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>

        <res-publication-edit-access-data
            [publication]="publication">
        </res-publication-edit-access-data>

		<!-- #anchor dynamic field container -->
		<ng-template #dynamicFieldSetContainer></ng-template>

		<res-identifier-panel *ngIf="publication.publicationType"
            [hisDynamicContent]="'fs.res.publication.GlobalIdentifier'" [dynamicComponent]="publication._dynamicComponent"
			[globalIdentifiers]="publication.globalIdentifiers"
			(globalIdentifiersChange)="onGlobalIdentifiersChange($event)"
			[dynamicComponent]="publication._dynamicComponent"
			[context]="'publication'"
			[dDKey]="getDdKey('globalIdentifiers')"
			[customContentTemplate]="duplicatesTemplate">
		</res-identifier-panel>

		<ng-template #duplicatesTemplate>
            <res-display-duplicates
                [duplicates]="duplicates" route="/pub/view" duplicatesMessageSuffix="byIdentifier" (linkClicked)="onBeforeNavigate()">
            </res-display-duplicates>
		</ng-template>

		<!-- #anchor dynamic field container -->
        <ng-template #dynamicFieldSetContainer></ng-template>
	</div>
</div>
